import { useCallback } from "react";
import { useAddToCart, useAddToCartEnabled } from "./add-to-cart";
import { useRemoveFromCart, useRemoveFromCartEnabled } from "./remove-from-cart";
import { useCallbacks } from "../InternalContext";

export const useRunCallback = (): ((name: string, args?: Record<string, any>) => void) => {
    const runAddToCart = useAddToCart();
    const runRemoveFromCart = useRemoveFromCart();
    const callbacks = useCallbacks();

    return useCallback((name: string, args?: Record<string, any>): void => {
        switch (name) {
            case "add-to-cart":
                runAddToCart();
                break;
            case "remove-from-cart":
                runRemoveFromCart();
                break;
            default:
                const customCallback = callbacks?.[name];
                if (customCallback?.func) {
                    customCallback.func(args || {});
                }
                break;
        }
    }, [runAddToCart, runRemoveFromCart, callbacks]);
}

export const useCallbackEnabled = (): ((name: string, args?: Record<string, any>) => boolean) => {
    const addToCartEnabled = useAddToCartEnabled();
    const removeFromCartEnabled = useRemoveFromCartEnabled();
    const callbacks = useCallbacks();

    return useCallback((name: string, args?: Record<string, any>): boolean => {
        switch (name) {
            case "add-to-cart":
                return addToCartEnabled();
            case "remove-from-cart":
                return removeFromCartEnabled();
            default:
                const customCallback = callbacks?.[name];
                if (customCallback?.enabledFunc) {
                    return customCallback.enabledFunc(args || {});
                }
                return false;
        }
    }, [addToCartEnabled, removeFromCartEnabled, callbacks]);
}


